// src/contexts/ShippingContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { db } from "../firebase/firebase";
import { doc, onSnapshot, setDoc } from "firebase/firestore";

const ShippingContext = createContext(null);

export const DEFAULT_SHIPPING_COST = 100;

export function ShippingProvider({ children }) {
  const [shippingCost, setShippingCost] = useState(DEFAULT_SHIPPING_COST);
  const [shippingLoading, setShippingLoading] = useState(true);

  useEffect(() => {
    const ref = doc(db, "siteSettings", "ShippingSettings");
    const unsubscribe = onSnapshot(ref, (snap) => {
      if (snap.exists()) {
        const data = snap.data();
        setShippingCost(
          typeof data.shippingCost === "number"
            ? data.shippingCost
            : DEFAULT_SHIPPING_COST
        );
      } else {
        setShippingCost(DEFAULT_SHIPPING_COST);
      }
      setShippingLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const saveShippingCost = async (newCost) => {
    const ref = doc(db, "siteSettings", "ShippingSettings");
    await setDoc(ref, { shippingCost: Number(newCost) }, { merge: true });
  };

  return (
    <ShippingContext.Provider value={{ shippingCost, shippingLoading, saveShippingCost }}>
      {children}
    </ShippingContext.Provider>
  );
}

export function useShipping() {
  return useContext(ShippingContext);
}
